import { useEffect, useRef, useState } from "react";
import styled from "styled-components";

import { projects } from "../../data";
import Project from "./Project";

const ProjectsList = () => {
  const [reveal, setReveal] = useState(false);
  const myRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      setReveal(entry.isIntersecting);
    });
    observer.observe(myRef.current);
  }, []);

  const handleClick = (link) => {
    window.open(link, "_blank");
  };

  return (
    <Container ref={myRef} className={reveal ? "show" : "hidden"}>
      <Text>projects</Text>
      <StyledProjectsList>
        {projects.map((item) => {
          return (
            <Project
              key={item.id}
              item={item}
              handleClick={() => handleClick(item.link)}
            />
          );
        })}
      </StyledProjectsList>
    </Container>
  );
};

export default ProjectsList;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
`;

const StyledProjectsList = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-wrap: wrap;
  width: 100%;
  padding: 1rem;

  @media (max-width: 850px) {
    flex-direction: column;
  }
`;

const Text = styled.div`
  font-size: 2rem;
  margin: 50px 0px;
  text-align: center;
`;
